import React, { useEffect, useState } from 'react';
import { useTheme } from "../../Theme";
import scroll from '../../Resources/floaters/scroll.png';

const Floaters = () => {
  const [visible, setVisible] = useState(false);
  const { isDarkMode, toggleDarkMode } = useTheme();
  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [isDarkMode]);
  const toggleVisibility = () => {
    if (window.scrollY > 20) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <>
        <img 
        src={scroll} 
        className={`scrollUp ${visible ? 'show' : 'hide'}`} 
        onClick={scrollToTop} 
        alt="Scroll to Top" 
        />
        <div className={`theme_switcher ${isDarkMode ? '':'dark_theme'}`} onClick={toggleDarkMode}>
            <div className={`dark_mode_switch ${isDarkMode ? '':'light'}`} />
        </div>
        <div className="theme_switch_popup floating_popup">
          Click to toggle theme
        </div>
    </>
  );
};

export default Floaters;
